import { component } from 'picoapp'

export default component((node, ctx) => {

  const openClass = 'is-open';
  const headings = node.querySelectorAll('.mobile-collection-btn')
  const contents = node.querySelectorAll('.collection-nav')

  const toggleAccordion = function(e) {
    e.preventDefault();
    if (e.target.classList.contains(openClass)) {
      closeAll();
    } else {
      const i = e.target.getAttribute('data-index');
      closeAll();
      open(i);
    }
  }

  const open = function(i, userInitiated = true) {
    headings[i].classList.add(openClass);
    contents[i].classList.add(openClass);

    if (userInitiated) {
      setTimeout(function() {
        headings[i].scrollIntoViewIfNeeded();
      }, 1);
    }
  }

  const close = function(i) {
    headings[i].classList.remove(openClass);
    contents[i].classList.remove(openClass);
  }

  const closeAll = function() {
    for (let i = 0; i < contents.length; i++) {
      close(i);
    }
  }

  for (let i = 0; i < headings.length; i++) {
    headings[i].setAttribute('data-index', i)
    headings[i].addEventListener('click', toggleAccordion)
  }

})
